import type { schemas } from '@gonfalon/openapi/types';

/**
 * Derives the member id / team key from an AI Config `_maintainer` rep (shared by AI configs, tools, and
 * prompt snippets, which all use the `AIConfig__maintainer` shape). Returns the member id under
 * `maintainerId` and the team key under `maintainerTeamKey`; exactly one is set, or neither when there is
 * no maintainer.
 */
export function extractMaintainerIds(maintainer: schemas['AIConfig__maintainer'] | undefined): {
  maintainerId?: string;
  maintainerTeamKey?: string;
} {
  if (!maintainer) {
    return { maintainerId: undefined, maintainerTeamKey: undefined };
  }
  if (maintainer.kind === 'member' && '_id' in maintainer) {
    return { maintainerId: maintainer._id, maintainerTeamKey: undefined };
  }
  if (maintainer.kind === 'team' && 'key' in maintainer) {
    return { maintainerId: undefined, maintainerTeamKey: maintainer.key };
  }
  return { maintainerId: undefined, maintainerTeamKey: undefined };
}
